import { Injectable } from '@angular/core';
import { AbstractGraphqlRequest, GraphqlRequestType } from '@ckmk/angular';
import { TypedDocumentNode } from '@apollo/client';
import { ServiceCategoryModel } from '@app/src/app/modules/service/classes/category/model/service.category.model';
import { gql } from 'apollo-angular';

@Injectable({
  providedIn: 'root',
})
export class ServiceCategoryRequestMutation extends AbstractGraphqlRequest<ServiceCategoryModel> {
  protected override type: GraphqlRequestType = 'mutation';

  protected override getQuery(payload: any): TypedDocumentNode<any, any> {
    if (payload.data?.id) {
      return gql`
        mutation updateServiceCategory($data: ServiceCategoryUpdateInput!) {
          updateServiceCategory(data: $data) {
            id
            cover {
              id
              name
              originalName
              extension
              active
              title
              description
              directory
              directories
              chunkEnd
              chunkStart
              frontUrls

              mimetype
              temp
              createdAt
              updatedAt
              createdBy
              updatedBy
            }
            slug
            title
            description
            shortDescription
            data {
              leftColor
              rightColor
            }
            active
            createdAt
            updatedAt
            deletedAt
            createdBy
            updatedBy
          }
        }
      `;
    }

    return gql`
      mutation createServiceCategory($data: ServiceCategoryCreateInput!) {
        createServiceCategory(data: $data) {
          id
          cover {
            id
            name
            originalName
            extension
            active
            title
            description
            directory
            directories
            chunkEnd
            chunkStart
            frontUrls

            mimetype
            temp
            createdAt
            updatedAt
            createdBy
            updatedBy
          }
          slug
          title
          description
          shortDescription
          data {
            leftColor
            rightColor
          }
          active
          createdAt
          updatedAt
          deletedAt
          createdBy
          updatedBy
        }
      }
    `;
  }

  protected override onParseResult(data: any, payload?: any) {
    const categoryData =
      data.createServiceCategory || data.updateServiceCategory;

    if (categoryData) {
      return new ServiceCategoryModel(categoryData);
    }

    return null;
  }
}
